import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./Loading.css"; // Optional for styling
import OrderSuccess from "../ordersuccess/OrderSuccess";

const Loading = () => {
  const [showOrderSuccess, setShowOrderSuccess] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowOrderSuccess(true);
    }, 3000); // 3 seconds
    return () => clearTimeout(timer);
  }, []);

  const params = new URLSearchParams(location.search);
  const isUploadCheque = location.pathname === "/uploadcheque";
  const isFPX = params.get("type") === "fpx";

  const redirectText = isUploadCheque && isFPX ? "FPX" : "IBG";

  return (
    <div className="loading">
      <div className="loading-spinner"></div>
      <div className="loading-text">
        Redirect to Payment {redirectText} Page
        <br />
        <strong>
          Please do not navigate away from this page or press the back button
          until payment is completed.
        </strong>
      </div>
      {!isUploadCheque && showOrderSuccess && (
        <OrderSuccess onClose={() => setShowOrderSuccess(false)} />
      )}
    </div>
  );
};

export default Loading;
